// Runtime settings keys
export const YANDEX_API_KEY_CONFIG_KEY = 'builders.YandexApiKey';
export const YANDEX_SUGGEST_API_KEY_CONFIG_KEY = 'builders.YandexSuggestApiKey';

export const MAP_CONTAINER_ID = 'mapsSection';
